// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';
// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)


// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';


const d3 = require('d3');
const mapboxgl = require('mapbox-gl');

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';

let isMobile = window.innerWidth < 500;

const mobileLocation = ['-94.5', '39'];
const desktopLocation = ['-96', '38.9'];
const startLocation = isMobile ? mobileLocation : desktopLocation;

const mobileZoom = 2;
const desktopZoom = 3.4;
const startZoom = isMobile ? mobileZoom : desktopZoom;

const forecastMap = new mapboxgl.Map({
  container: 'snow-forecast-map',
  // style: 'mapbox://styles/cnndigital/cl960ytee001215qu1uhorjlx',
  style: 'mapbox://styles/cnndigital/cmbfliit7009r01s1hvcoe2pb',
  center: [startLocation[0], startLocation[1]],
  zoom: startZoom,
  minZoom: 2,
  maxZoom: 6,
  bearing: 0,
  scrollZoom: false,
  dragRotate: false,
  touchPitch: false,
  interactive: true,
  projection: 'albers',

});
forecastMap.addControl(new mapboxgl.NavigationControl({
  showCompass: false,
}), 'top-right');

forecastMap.on('load', () => {
  // Find first symbol layer to insert below labels
  let firstSymbolId;
  for (const layer of forecastMap.getStyle().layers) {
    if (layer.type === 'symbol') {
      firstSymbolId = layer.id;
      break;
    }
  }

  // Add state boundaries source
  forecastMap.addSource('us-states', {
    type: 'geojson',
    data: 'https://ix.cnn.io/data/gis/usa_states_conus.geojson',
  });

  // Add state borders layer (on top of snow, below labels)
  forecastMap.addLayer({
    id: 'state-borders',
    type: 'line',
    source: 'us-states',
    paint: {
      'line-color': '#999',
      'line-width': 0.5,
    },
  }, firstSymbolId);

  // Add snow forecast source and layer
  forecastMap.addSource('snow3', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxsnowfore3',
  });

  forecastMap.addLayer({
    id: 'snow3',
    type: 'raster',
    source: 'snow3',
    layout: { visibility: 'visible' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  }, 'state-borders'); // Insert below state borders

  pymChild.sendHeight();
});

// Update height when map resizes
forecastMap.on('resize', () => {
  pymChild.sendHeight();
});

// Also listen for window resize and adjust zoom/center if crossing mobile/desktop threshold
window.addEventListener('resize', () => {
  const wasMobile = isMobile;
  isMobile = window.innerWidth < 500;

  // If crossed the threshold, adjust zoom and center
  if (wasMobile !== isMobile) {
    const newZoom = isMobile ? mobileZoom : desktopZoom;
    const newCenter = isMobile ? mobileLocation : desktopLocation;
    forecastMap.setZoom(newZoom);
    forecastMap.setCenter(newCenter);
  }

  pymChild.sendHeight();
});

d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});

d3.json('https://ix.cnn.io/data/wx-snow-forecast/forecast-date.json').then((data) => {
  const updateTime = d3.timeParse('%Y-%m-%dT%H:%M:%S%Z')(`${data.timestamp}Z`);

  // Update dek with date range, but stop after Jan 26, 2026
  const cutoffDate = new Date('2026-01-26T23:59:59');
  const today = new Date();

  if (today <= cutoffDate) {
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + 3);

    const formatDate = d3.timeFormat('%b %-d');
    const startStr = formatDate(today);
    const endStr = formatDate(endDate);

    d3.select('.subhed.dek')
      .html('<p>The winter storm is expected to produce large amounts of snow across more than a dozen states.</p>');

    d3.select('#forecast-map-timestamp')
      .text(`Note: Forecast through ${endStr} and updated at ${d3.timeFormat('%-I:%M %p on %b %-d, %Y')(updateTime)}. Only data for the contiguous United States shown.`);
  }


  // Send height after footer content is added
  pymChild.sendHeight();
});
